import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faShieldAlt,
    faInfoCircle,
    faClock,
} from "@fortawesome/free-solid-svg-icons";

export default function PaymentNoticeBanner() {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="relative overflow-hidden rounded-2xl border border-cyan-700/40"
        >
            {/* Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-900 via-blue-900 to-purple-900 animate-pulse opacity-90" />

            {/* Content */}
            <div className="relative p-4 md:p-5 text-white">

                {/* Header */}
                <div className="flex items-center gap-2 mb-2">
                    <FontAwesomeIcon
                        icon={faShieldAlt}
                        className="text-cyan-300"
                    />
                    <h2 className="text-sm text-cyan-200 font-semibold">
                        Secure Payments Coming Soon
                    </h2>
                </div>

                {/* Body */}
                <div className="text-xs md:text-sm text-gray-200 space-y-2 leading-relaxed">

                    <div className="flex gap-2 items-start">
                        <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="text-cyan-300 mt-1"
                        />
                        <p className="text-xs text-gray-100">
                            We are actively working with our FinTech partner to enable
                            secure and seamless online payments.
                        </p>
                    </div>

                    <div className="flex gap-2 items-start">
                        <FontAwesomeIcon
                            icon={faClock}
                            className="text-yellow-300 mt-1"
                        />
                        <p className="text-xs text-gray-100">
                            Thank you for your patience while we enhance your payment experience.
                        </p>
                    </div>

                    <div className="flex gap-2 items-start">
                        <FontAwesomeIcon
                            icon={faShieldAlt}
                            className="text-green-300 mt-1"
                        />
                        <p className="text-xs text-gray-100">
                            Meanwhile, please continue using our trusted digital partner
                            for subscriptions and paid services.
                        </p>
                    </div>
                </div>

                {/* Footer */}
                <div className="mt-3 text-[11px] text-cyan-200 opacity-80">
                    🔒 Your transactions remain secure and verified
                </div>
            </div>
        </motion.div>
    );
}